import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FluentField } from "./Fluent-Field";
import { FluentCheckbox } from "./Fluent-Checkbox";
import "./fluent-overide.scss";

export const FluentMultiSelectCheckboxes = ({
  label,
  disabled,
  validationMessage,
  required,
  options,
  defaultValue,
  onChange,
}) => {
  const [checked, setChecked] = useState(new Set(defaultValue?.split("|").filter(Boolean)));

  // Sync internal state when defaultValue changes (e.g., on form reset)
  useEffect(() => {
    setChecked(new Set(defaultValue?.split("|").filter(Boolean)));
  }, [defaultValue]);

  const handleCheckboxChange = (newValue) => {
    const updatedChecked = new Set(checked);
    if (updatedChecked.has(newValue)) {
      updatedChecked.delete(newValue);
    } else {
      updatedChecked.add(newValue);
    }

    setChecked(updatedChecked);
    onChange({ target: { value: Array.from(updatedChecked).join("|") } }); 
  };

  return (
    <FluentField
      label={label}
      validationMessage={validationMessage}
      required={required}
    >
      <div className="multi-select-checkboxes">
        {options.map((option) => (
          <FluentCheckbox
            key={option}
            label={option}
            checked={checked.has(option)}
            onChange={() => handleCheckboxChange(option)}
            disabled={disabled}
            // TAD-5894 — The wrapping FluentField passes `required` to every
            // descendant control through Fluent's Field context, which made each
            // option render its own required asterisk. The checkbox GROUP is what
            // is required (the asterisk belongs on the field label, shown once via
            // FluentField above); individual options are never individually
            // required, so force it off here.
            required={false}
          />
        ))}
      </div>
    </FluentField>
  );
};

FluentMultiSelectCheckboxes.propTypes = {
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  validationMessage: PropTypes.string,
  required: PropTypes.bool,
  defaultValue: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};
